import React, { useState } from 'react';
import './style.sass';

export default function InputType ({...params }) {

    const {
        type,
        name,
        id,
        placeholder,
        value,
        change,
        focus,
        errorMessage,
        max,
        min,
        refs,
        readonly,
        disabled,
        autocomplete,
        children
    } = params

    return(
        <label className="fileset" aria-label={placeholder}>
            <input
                type={type}
                name={name}
                id={id}
                placeholder={placeholder}
                onChange={change}
                onFocus={focus}
                value={value}
                max={max}
                min={min}
                readonly={readonly}
                disabled={disabled}
                autoComplete={autocomplete}
                data-input={autocomplete}
                ref={refs}
            />
            {children}
            
            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </label>
    )
}

// Input tipo android
export function InputTypeAndroidDos({ ...params }) {

    const {
        type,
        name,
        id,
        placeholder,
        value,
        change,
        onFocus,
        errorMessage,
        max,
        min,
        refs,
        readonly,
        disabled,
        autocomplete,
        children,
        maxLength,
        onKeyDown,
        minLength,
        onChange,
        className,
        oncopy,
        onpaste
    } = params


    return (
        < div className={className && className === "desktopInput" ? "fieldset2 desktopInput" : className && className !== "desktopInput" ? "fieldset2 w25" : "fieldset2"}>
            <input
                onChange={onChange}
                type={type}
                name={name}
                id={id}
                placeholder=" "
                onFocus={onFocus}
                value={value}
                // max={max}
                // min={min}
                readOnly={readonly}
                disabled={disabled}
                autoComplete={autocomplete}
                data-input={autocomplete}
                ref={refs}
                maxLength={maxLength}
                minLength={minLength}
                onKeyDown={onKeyDown}
                onCopy={oncopy}
                onPaste={onpaste}
            />
            <label htmlFor={id} for={id}>{placeholder}</label>
            {/* {children} */}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}

// Input tipo android
export function InputTypeAndroid({ ...params }) {

    const {
        type,
        name,
        id,
        placeholder,
        value,
        change,
        focus,
        errorMessage,
        max,
        min,
        refs,
        readonly,
        disabled,
        autocomplete,
        children,
        maxLength,
        setNumero,
        onKeyDown,
        minLength

    } = params


    const handleNumero = (e) => {
        let numero = e.target.value;
        setNumero(numero);
        // console.log("numero escrito: ", numero);
    }

    return (
        < div className="fieldset2">
            <input
                type={type}
                name={name}
                id={id}
                placeholder=" "
                onChange={change}
                onFocus={focus}
                value={value}
                max={max}
                min={min}
                readOnly={readonly}
                disabled={disabled}
                autoComplete={autocomplete}
                data-input={autocomplete}
                ref={refs}
                maxLength={maxLength}
                minLength={minLength}
                onChange={handleNumero}
                onKeyDown={onKeyDown}
            />
            <label htmlFor={id} for={id}>{placeholder}</label>
            {/* {children} */}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}
